const BasicPrimaryButton = (props) =>
    <button type="button" className="inline-flex items-center rounded-md py-2 px-4 text-sm font-medium shadow-sm
    bg-green-500 dark:bg-green-600 text-white hover:bg-green-600 dark:hover:bg-green-500
    disabled:opacity-70 hover:disabled:bg-green-500 dark:hover:disabled:bg-green-600" {...props}/>

export default BasicPrimaryButton;